import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import { getBookingStatus } from '../api/client';

const STATUS_MAP = {
  pending: { label: 'Ожидает подтверждения', badge: 'badge-pending', icon: '⏳', desc: 'Мы скоро свяжемся с вами для подтверждения.' },
  confirmed: { label: 'Подтверждено', badge: 'badge-confirmed', icon: '✅', desc: 'Бронь подтверждена. Ожидаем оплату.' },
  paid: { label: 'Оплачено', badge: 'badge-paid', icon: '🎉', desc: 'Всё готово! Ждём вас.' },
  cancelled: { label: 'Отменено', badge: 'badge-cancelled', icon: '❌', desc: 'Бронь была отменена.' },
};

export default function BookingStatusPage() {
  const { ref } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getBookingStatus(ref)
      .then(setBooking)
      .catch(() => setError('Бронирование не найдено. Проверьте номер заявки.'))
      .finally(() => setLoading(false));
  }, [ref]);

  const statusInfo = booking ? (STATUS_MAP[booking.status] || STATUS_MAP.pending) : null;

  return (
    <div>
      <Header showBack />
      <div className="container" style={{ maxWidth: 560, padding: '40px 16px 80px' }}>
        {loading && <div style={{ textAlign: 'center', padding: 60 }}><div className="spinner" style={{ width: 40, height: 40 }} /></div>}
        {error && (
          <div>
            <div className="alert alert-error">{error}</div>
            <Link to="/" className="btn btn-primary">На главную</Link>
          </div>
        )}
        {booking && statusInfo && (
          <div className="card" style={{ padding: 32 }}>
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>{statusInfo.icon}</div>
              <span className={`badge ${statusInfo.badge}`} style={{ fontSize: 14, padding: '6px 16px' }}>
                {statusInfo.label}
              </span>
              <p style={{ marginTop: 12, color: 'var(--gray-600)', fontSize: 15 }}>{statusInfo.desc}</p>
            </div>

            <div style={{ borderTop: '1px solid var(--gray-200)', paddingTop: 20 }}>
              {[
                ['Номер заявки', booking.booking_ref],
                ['Квартира', booking.apartment_name],
                ['Адрес', booking.address],
                ['Заезд', booking.check_in],
                ['Выезд', booking.check_out],
                ['Ночей', booking.nights],
                ['Гостей', booking.num_guests],
                ['Итого', `${new Intl.NumberFormat('ru-RU').format(booking.total_price_rub)} ₽`],
              ].map(([label, value]) => value && (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid var(--gray-100)', fontSize: 14 }}>
                  <span style={{ color: 'var(--gray-500)' }}>{label}</span>
                  <span style={{ fontWeight: 600 }}>{value}</span>
                </div>
              ))}
            </div>

            <div style={{ marginTop: 24, textAlign: 'center' }}>
              <Link to="/" className="btn btn-secondary">← На главную</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
